import {
  createStyles,
  lighten,
  makeStyles,
  Theme,
} from '@material-ui/core/styles';

export const useDeleteButtonStyles = makeStyles(() =>
  createStyles({
    padding: {
      padding: '4px',
    },
  }),
);

export const useTableRowStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableRowRootAdded: {
      backgroundColor: lighten(theme.palette.success.light, 0.65),
      color: theme.palette.success.dark,
      '&:nth-of-type(n)': {
        backgroundColor: lighten(theme.palette.success.light, 0.65),
        color: theme.palette.success.dark,
      },
      '&> th': {
        color: theme.palette.success.dark,
      },
    },
    tableRowRootDefault: {
      backgroundColor: theme.palette.background.paper,
      '&:nth-of-type(n)': {
        backgroundColor: theme.palette.background.paper,
      },
    },
    tableRowRootRemoved: {
      backgroundColor: lighten(theme.palette.error.light, 0.65),
      color: theme.palette.error.dark,
      '&:nth-of-type(n)': {
        backgroundColor: lighten(theme.palette.error.light, 0.65),
        color: theme.palette.error.dark,
      },
      '&> th': {
        color: theme.palette.error.dark,
      },
    },
  }),
);
